import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getLobType = async () => {
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_BASEURL}/ProducerCode/LineOfBusiness`
  );
  return data;
};
//Insert New LobType
export const addLobType = async (newLobType) => {
  const { data } = await axios.post(
    `${api_base_url}/Configuration/LobType`,
    ...newLobType
  );
  return data;
};
// Update LobType

export const updateLobType = async (updatedLobType) => {
  const { data } = await axios.put(
    `${api_base_url}/Configuration/LobType${updatedLobType[0].lobid}`,
    ...updatedLobType
  );
  return data;
};

//Delete LobType by Id
export const deleteLobType = async (LobTypeId) => {
  await axios.delete(`${api_base_url}/LobType/${LobTypeId}`);
};
//

export const deleteLobTypes = async (lobIds) => {
  await axios.delete(`${api_base_url}/configuration/lobtype/delete`, {
    data: lobIds,
  });
};
